import getPaginatedTastings from '@/api/getPaginatedTastings';
import { useQuery } from '@tanstack/react-query';

function useFetchPaginatedTastings(
  locale: string,
  scope: 'upcoming' | 'past',
  page: number,
  pageSize: number
) {
  return useQuery({
    queryKey: ['tastings', locale, scope, page, pageSize],
    queryFn: () => getPaginatedTastings(locale, scope, page, pageSize),
  });
}

export { useFetchPaginatedTastings };
